import { Directive, HostListener } from '@angular/core';
import { NG_VALIDATORS, NgControl } from '@angular/forms';

@Directive({
  selector: '[appRestrictSpecialChars]',
})
export class RestrictSpecialCharsDirective {
  constructor(private ngControl: NgControl) {}
  
  private regex = /[%*?|,:<>&\/"\\+$\t]/g; // The characters we want to restrict

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // If the tab key is pressed, prevent the default behavior
    if (event.key === 'Tab') {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let initialValue = this.ngControl.control.value;
    // Replace any character that is not alphanumeric or a space
    initialValue = initialValue.replace(this.regex, '');
    // Update the input value
    this.ngControl.control.setValue(initialValue);
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/directives/restrict-special-chars.directive.ts